import React from "react"
import Layout from "../components/layout"
import CsoundInstr from "../components/lib/csoundinstr"
import Components from "../components/lib/components"
import { Row, Col } from "react-bootstrap"
import { withPrefix } from "gatsby"
import Waveterrain from "../components/Waveterrain"


class IndexPage extends React.Component {
  constructor() {
    super()
    this.inst = {
      components: [
        {
          type: "panel", id: "main", vertical: true, wrap: true, widgets: [
            {
              type: "panel", id: "wtpanel", widgets: [
                {
                  id: "wt",
                  label: "waveterrain",
                  func: this.wtfunc.bind(this),
                  defval: { x: 0, y: 0, rx: 0.5, ry: 0.5, rot: 0, curve: 3, p1: 1.05, gst1: "10 1", gst2: "10 1" },
                },
              ],
            },
            {
              type: "panel", id: "ctrl", wrap: true, widgets: [
                Components.lfo("lfox", "lfo_x"),
                Components.lfo("lfoy", "lfo_y"),
                Components.lfo("lfop", "lfo_p"),
                Components.lfo("lforx", "lfo_rx"),
                Components.lfo("lfory", "lfo_ry"),
                Components.lfo("lforot", "lfo_rot", 6.28),
                { type:"panel", id:'adsrpanel',vertical:true, widgets:[
                    { type: "adsr", label:"adsr1",id: "adsr1", on: true, defval: { adsr1_a: 0.01, adsr1_d: 0, adsr1_s: 1, adsr1_r: 0.1 } },
                    { type: "adsr", label:"adsr2",id: "adsr2", defval: { adsr2_a: 0.01, adsr2_d: 0.10, adsr2_s: 0, adsr2_r: 0 } },
                  ]},
                {
                  type: "panel", label: "master", id: "master", widgets: [
                    { id: "amp", type: "fader", label: "amp", min: 0, max: 1, step: 0.01, defval: 0.6, height: 160, midictrl: 107 },
                    { id: "rev", type: "fader", label: "reverb", min: 0, max: 1, step: 0.01, defval: 0.6, height: 160, midictrl: 110 },
                    {
                      id: "filt",
                      type: "fader",
                      label: "filter",
                      log: true,
                      min: 40,
                      max: 15000,
                      step: 0.01,
                      defval: 10000,
                      height: 160,
                      size: 3,
                    },
                    { id: "ch", type: "fader", label: "rndch", min: 0, max: 1, step: 0.01, defval: 0, height: 160, midictrl: 108 },
                  ],
                },
              ],
            },
          ],
        },
      ],
    }
    this.tunings = [
      {
        name: "blue",
        basekey: 0,
        basefreq: 8.25,
        scale: [1, 21 / 20, 10 / 9, 7 / 6, 5 / 4, 21 / 16, 7 / 5, 3 / 2, 25 / 16, 5 / 3, 7 / 4, 15 / 8],
      },
      {
        name: "overtone",
        basekey: 0,
        basefreq: 8.25,
        scale: [1, 17 / 16, 9 / 8, 19 / 16, 5 / 4, 21 / 16, 11 / 8, 3 / 2, 13 / 8, 27 / 16, 7 / 4, 15 / 8],
      },
      {
        name: "monte",
        basekey: 10,
        basefreq: 4.58333,
        scale: [1, 64 / 63, 9 / 8, 8 / 7, 7 / 6, 4 / 3, 21 / 16, 3 / 2, 32 / 21, 14 / 9, 16 / 9, 7 / 4],
      },
    ]
    this.csoundInstr = React.createRef()
    this.waveTerrain = React.createRef()
  }

  onStart() {
    console.log("index on start")
    this.waveTerrain.current.onStart()
  }

  wtfunc(component, changeFunc) {
    return (
      <Waveterrain ref={ref => this.waveTerrain.current = ref} cs={this.csoundInstr.current} def={component}
                   key={component.id} onChange={changeFunc} />
    )
  }

  render() {
    return (
      <Layout>
        <Col>
          <Row>
            <Col>
              <h2>Wave Terrain</h2>
            </Col>
          </Row>
          <Row>
            <Col>This instrument demonstrates the <a target="_blank"
                                                        href="https://csound.com/docs/manual/wterrain2.html">wterrain2</a> opcode
            from <a target="_blank" href="https://csound.com">Csound</a>
            </Col>
          </Row>
          <Row>
            <Col>
              <CsoundInstr onStart={this.onStart.bind(this)} ref={ref => this.csoundInstr.current = ref}
                                  csoundwasm={withPrefix("csound.esm.js")} inst={this.inst} keyboard="wt" osc="wt"
                                  csd={withPrefix("waveterrain.csd")} plugins={[]} tunings={this.tunings} />
            </Col>
          </Row>
        </Col>
      </Layout>
    )
  }
}

export default IndexPage
